module.exports = __webpack_public_path__ + "static/media/hurricane.d9e45a16.glb";